export default class Vector2
{
    constructor(x : number, y : number)
    {
        this.x = x;
        this.y = y;
    }
    
    static parse(input : string) : Vector2
    {
        let i = input.indexOf("{");
        if (i != -1)
        {
            input = input.substr(i + 1, input.length - (2 + i));
        }
        let inputs = input.split(",");
        
        return new Vector2(Number.parseFloat(inputs[0]), Number.parseFloat(inputs[1]));
    }

    public x : number;
    public y : number;

    public toString() : string
    {
        return "{" + this.x + "," + this.y + "}";
	}
	
	/**
	 * Returns a copy of the vector multiplied by the scale
	 * @param scale Value to scale by
	 */
	public scale(scale : number)
	{
		return new Vector2(this.x * scale, this.y * scale);
	}

	public add(vec : Vector2)
	{
		let res = new Vector2(this.x, this.y);
		res.x += vec.x;
		res.y += vec.y;
		return res;
	}

	public sub(vec : Vector2)
	{
		let res = new Vector2(this.x, this.y);
		res.x -= vec.x;
		res.y -= vec.y;
		return res;
	}

	public magnitude()
	{
		return Math.sqrt(this.x * this.x + this.y * this.y);
	}

	public normalize() : void
	{
		let mag = this.magnitude();
		this.x /= mag;
		this.y /= mag;
	}
}